import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, CheckCircle2, ArrowLeft } from "lucide-react";
import { Brand } from "@/components/Brand";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.forgotPassword({ email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <Brand variant="auth" />

        <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-6 space-y-4">
          {sent ? (
            <div className="text-center space-y-3 py-4" data-testid="forgot-sent">
              <CheckCircle2 className="h-10 w-10 text-green-500 mx-auto" />
              <h2 className="font-display text-lg font-bold text-slate-900">Check your email</h2>
              <p className="text-sm text-slate-500">If that email is registered, a reset link has been sent. It expires in 1 hour.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
              <div>
                <h2 className="font-display text-lg font-bold text-slate-900">Reset password</h2>
                <p className="text-sm text-slate-500">Enter your email and we'll send you a reset link.</p>
              </div>
              {error && <p className="text-sm text-red-600">{error}</p>}
              <div className="space-y-1.5">
                <Label>Email</Label>
                <Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              <Button data-testid="forgot-submit" type="submit" disabled={busy} className="w-full bg-blue-600 hover:bg-blue-700">
                {busy ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Sending...</> : "Send reset link"}
              </Button>
            </form>
          )}
          <div className="text-center pt-1">
            <Link to="/login" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-900">
              <ArrowLeft className="h-3.5 w-3.5" /> Back to sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
